import { Component, input } from '@angular/core';
import { BenefitsListComponent } from '../benefits-list/benefits-list.component';
import { BenefitsListItem } from '../benefits-list/models/benefits-list-item.interface';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-benefits-list-covered-items',
  templateUrl: './benefits-list-covered-items.component.html',
  styleUrl: './benefits-list-covered-items.component.scss',
  imports: [BenefitsListComponent, IconComponent],
})
export class BenefitsListCoveredItemsComponent {
  title = input<string | undefined>(`What's covered`);
  benefitsListCoveredItems = input<BenefitsListItem[]>([]);
}
